import BackboneElement from './BackboneElement';
import CodeableConcept from './types/CodeableConcept';

import merge from 'lodash/merge';

export default class EncounterHospitalization extends BackboneElement {
    static __className = 'EncounterHospitalization';

    __objectStructure = {
        admitSource: CodeableConcept, // From where patient was admitted (NUBC point of origin)
        dischargeDisposition: CodeableConcept, // Category or kind of location after discharge (NUBC patient discharge status)
    };

    constructor(constructJson, className = 'EncounterHospitalization') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
